import React from 'react';

import ActivityTypeIcon from 'bundles/apex/activities/type/icon';
import UserIcon from 'components/user_icon';

import type { Activity } from 'bundles/apex/activities/types';

interface Props {
  activity: Activity;
}

export default function ActivityIcon({ activity }: Props) {
  return (
    <div>
      <div className="position-relative">
        <UserIcon size={32} user={activity.creator} />
        <ActivityTypeIcon
          activityType={activity.activityType}
          circled
          small
          style={{ position: 'absolute', right: -4, bottom: -4 }}
        />
      </div>
    </div>
  );
}
